import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../services/session';
import { refreshPage } from '../lib/utils';

@Injectable()
export class LoadboardRedirectGuard {
  public session: Session;
  public router: Router;

  constructor(session: Session, router: Router) {
    this.session = session;
    this.router = router;
  }

  public canLoad(): boolean {
    // Reloading page with current URL so it will pick and bootstrap load-board from index.ts/index.aot.ts
    refreshPage();
    return false;
  }
}
